import { IconMapPin } from '@react/common/icons'

function MapInfoWindow({ location, handleClose }) {
  return (
    <div className="map-info-window absolute bottom-[calc(100%+24px)] left-1/2 z-10 w-[320px] -translate-x-1/2 font-sans lg:w-[420px]">
      <button
        type="button"
        aria-label="Close popup"
        onClick={handleClose}
        className="absolute top-0 right-0 w-8 h-8 text-white rounded-bl-3xl transition-colors md:w-10 md:h-10 z-1 bg-green hover:bg-blue"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" className="relative left-0.5 -top-0.5 m-auto w-3/5 h-3/5">
          <path
            fill="currentColor"
            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
          />
        </svg>
      </button>

      <div className="flex overflow-hidden bg-white brand-shadow brand-rounded-sm-tl-br">
        <div className="flex-shrink-0 w-1/3">
          {location.thumbnail && (
            <img src={location.thumbnail} loading="lazy" alt={location.title} className="object-cover w-full h-full" />
          )}
        </div>

        <div className="flex relative flex-1 py-4 px-6 pr-12">
          <div className="my-auto w-full">
            <h2 className="text-base font-semibold transition-colors lg:text-lg text-green group-hover:text-blue">
              {location.title}
            </h2>

            <a
              href={location.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex gap-2 items-start mt-2 text-sm transition-colors lg:text-base hover:text-green"
            >
              <IconMapPin className="flex-shrink-0 w-4" />

              <address>
                {location.address}
                <br />
                {location.city}, {location.state} {location.zip}
              </address>
            </a>

            {location.detailsUrl && (
              <div className="mt-4">
                <a href={location.detailsUrl} className="py-2 px-5 text-xs md:text-sm btn btn-fill-primary">
                  <span>View Details</span>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MapInfoWindow
